import { EncryptStorage } from 'encrypt-storage';

const options = {
    storageType: 'sessionStorage',
}

export const encryptStorage = new EncryptStorage('34567gghhhGHYGH888VFGHDGHGDG5656G', options)

